const slugify = (string) => {
    if(!string) {
      string = '-';
    }
    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (!isIE11){
      string = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    return string.toLowerCase().replace(/\*\s?/g, '').replace(/[&\\#,+()$~%@.'"/:?<>{}!¡]/g,'').replace(/[-\s_]/g, '-').replace(/--+/g, '-').replace(/-$/, '');
};

const capitalize = (string) => {
  if (!string || string.length < 1) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
} 

export { slugify, capitalize };
  